import { createNanoEvents } from "nanoevents";

export const ScreenerGridEmitter = createNanoEvents<{
  copyAsTabSeparatedValues: () => void;
  exportAs: (format: "csv" | "xlsx") => void;
}>();
